export const GRADE_CB_TYPE = 'GRADE';
export const YEAR_CB_TYPE = 'YEAR';
export const CONTENT_CLASSIFICATION_CB_TYPE = 'CONTENT_CLASSIFICATION';
export const ITEM_TYPE_TYPE = 'ITEM_TYPE';
export const DIFFICULTY_LEVEL_CB_TYPE = 'DIFFICULTY_LEVEL';
export const CALCULATOR_TYPE = 'CALCULATOR_TYPE';
